// sl-712
// author - sachin
import React, { useEffect, useState } from "react";
import api from "../../seller-apis/api";
import axios from "axios";
import Progress from "./Progress";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { addPackage, resetPackageDimensions, resetPackages, setEditBtn, setPackageCount, setUploadProgress, updatePackage } from "../../Actions/PackageWeight";
import { Button, Container, Modal } from "react-bootstrap";
import img1 from "../../assets/images/packagImgUpload/img1.png"
import img2 from "../../assets/images/packagImgUpload/img2.png"
import img3 from "../../assets/images/packagImgUpload/img3.png"
import img4 from "../../assets/images/packagImgUpload/img4.png"
import "../common/WeightComponent.css";
import { GenUtilities } from "../../utilities/GenUtilities"
import { ftToCm, packagesFttoCm } from "../../utilities/conversion";
const WeightComponent = (props) => {
    const dispatch = useDispatch();
    const vendorId = localStorage.getItem('vendorId')
    const { packages, packageCount, uploadProgress, referencePackages, isPackageNull, dimensionUnit, isEditBtnActive } = useSelector((state) => state.packageReducer);
    const [disableUpload, setDisableUpload] = useState(false);
    const [showReference, setShowReference] = useState(false);
    const [show, setShow] = useState(false)
    const [editMode, setEditMode] = useState(false)


    // sl-824
    const [showWeightRequestBox, setShowWeightRequestBox] = useState(true)

    const alert = useAlert()
    useEffect(() => {
        if (props?.weightSubmit === true) {
            reset()
        }
    }, [props?.weightSubmit])


    useEffect(() => {
        if (packages.length < 1) {
            dispatch(resetPackages())
            setDisableUpload(false)
        }
    }, [packages])

    useEffect(() => {
        console.log("isEditBtnActive changed: ", isEditBtnActive);
    }, [isEditBtnActive])

    useEffect(() => {
        if (props?.curComArr && props?.weightRequest) {
            setShowWeightRequestBox(true)
            setDisableUpload(true)
        }
    }, [props?.curComArr])

    useEffect(() => {
        if (!showWeightRequestBox) {
            setDisableUpload(false)
        }
    }, [showWeightRequestBox])

    useEffect(() => {
        if (props?.rejectPackageSelected) {
            setShowWeightRequestBox(false)
        }
    }, [props?.rejectPackageSelected])



    useEffect(() => {
        if (!props?.curComArr && props?.weightRequest) {
            setDisableUpload(true)
        }
        if (props?.viewOnly) {
            setEditMode(false)
        }
    }, [])


    const formSpecificStyles = {
        spanNoPackage: {
            fontSize: "18px",
            color: "403939",
            marginRight: "20px"
        },
        addButton: {
            padding: "0px 30px",
            background: "#5F8D4E",
            color: "#FFFFFF",
            border: "1px solid #5F8D4E",
            marginRight: "20px",
            width: "104px",
            height: "46px",
            borderRadius: "5px",
            fontFamily: "'Open Sans', sans-serif",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "15px",
            lineHeight: "24px",
            textAlign: "center",
        },
        resetButton: {
            padding: "0px 30px",
            background: "#4e4f4f",
            color: "#FFFFFF",
            border: "1px solid #5F8D4E",
            marginRight: "20px",
            width: "104px",
            height: "46px",
            borderRadius: "5px",
            fontFamily: "'Open Sans', sans-serif",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "15px",
            lineHeight: "24px",
            textAlign: "center",
        },
        select: {
            width: "150px",
            marginRight: "20px",
            padding: "10px",
            border: "1px solid #D1C7C7",
            borderRadius: "3px",
            fontFamily: "'Open Sans', sans-serif",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            // lineHeight: "30px", // Uncomment if needed
            color: "#000000",
        },
    }

    const styles = {
        container: {
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
        },
        outerContainer: {
            padding: "20px 10px",
            boxSizing: "border-box",
            border: "1px solid"
        },
        column: (width) => ({
            flex: `0 0 ${width}`,
            maxWidth: width,
        }),
        imageGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(2, 64px)",
            gap: "6px",
        },
        imageUpload: {
            width: "65px",
            height: "65px",
            backgroundColor: "#f0f0f0",
            border: "2px dashed #ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            position: "relative",
        },
        inputGroup: {
            marginBottom: "15px",
        },
        input: {
            width: "100%",
            padding: "3px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            fontSize: "11px",
            boxSizing: "border-box",
        },
        row: {
            display: "flex",
            gap: "10px",
        },
        thirdWidth: {
            flex: "1",
        },
        kgLabel: {
            marginLeft: "4px",
            fontSize: "12px",
        },
        button: {
            padding: "10px 20px",
            fontSize: "16px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
        },
        packageList: {
            marginTop: "20px",
        },
        packageItem: {
            padding: "10px",
            border: "1px solid #ddd",
            marginBottom: "10px",
        },
        uploadImagesLabel: {
            fontSize: "12px",
            // color: "blue",
        },
        uploadImagesGuide: {
            fontSize: "11px",
            color: "red",
            cursor: "pointer"
        },
        label: {
            fontSize: "11px",
        },
        starIcon: {
            display: "contents"
        },
        updateBtnContainer: {
            display: "flex",
            justifyContent: "end",
            marginTop: "10px"
        },
        updateBtn: {
            minWidth: "190px",
            padding: "4px 4px",
            border: "none",
            background: "rgb(22, 91, 91)",
            borderRadius: "4px",
            borderStyle: "none",
            fontSize: "15px",
            color: "white",
            boxShadow: "rgb(208, 208, 208) 0px 0.2em 1em -0.2em"
        },
        spanPackage: {
            position: "relative",
            top: "11px",
            left: "20px",
            background: "white",
            padding: "0px 10px",
            fontSize: "13px"
        },
        spanNoPackage: {
            fontSize: "12px"
        },
        addButton: {
            padding: "3px 30px",
            background: "#165b5b",
            color: "white",
            fontSize:"14px",
            border: "none",
            width: "100px",
            marginLeft: "20px",
            borderRadius: "5px"
        },
        resetButton: {
            marginLeft: "20px",
            padding: "3px 10px",
            fontSize:"14px",
            background: "teal",
            color: "white",
            width: "100px",
            border: "none",
            borderRadius: "5px"
        },
        backBtn: {
            width: "140px",
            padding: "4px 0px",
            background: "#909090",
            color: "white",
            border: "none",
            borderRadius: "4px",
            marginRight: "20px",
            fontSize: "15px"
        },
        select: {
            width: "60px",
            padding: "0px 10px",
            marginLeft: "20px"
        },
        dimensionSelect: {
            width: "40px",
            marginLeft: "4px",
            background: "whitesmoke"
        },
        deleteIcon: {
            position: "absolute",
            top: "-2px",
            left: "45px",
            background: "red",
            color: "white"
        },
        volWeightTitle: {
            fontSize: '11px',
            color: 'teal'
        },
        refCloseBtn: {
            margin: "0px 10px",
            fontSize: "11px",
            padding: "1px 10px",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "6px"
            // boxShadow: "rgb(122, 27, 30) 0px 0.2em 1em -0.2em"
        },
        editCntnDiv: {
            position: 'relative',
        },
        editBtnStyle: {
            position: "absolute",
            right: "-7px",
            padding: "3px 8px",
            top: "-16px",
            border: "1px solid whitesmoke",
            borderRadius: "5px",
        },
        weightRequest: {
            container: {
                padding: "10px",
                background: "#fee"
            },
            btnContainer: {
                textAlign: "center",
                marginTop: "6px"
            },
            label: {
                fontSize: "14px",
                fontWeight: "bold",
                textAlign: "center"
            },
            button: {
                width: "70px",
            },
            yesBtn: {
                marginLeft: "50px",
            },
            noBtn: {
                marginRight: "50px",
                borderRadius: "2px",
                border: "1px solid #6d6d6d",
                background: "#fff",
                color: "#6d6d6d",
                fontSize: "11px",
                padding: "6px"
            },
        }
    }

    const handlePackageCountChange = (e) => {
        const count = parseInt(e.target.value);
        dispatch(setPackageCount(count))
    };

    const addPackages = () => {
        dispatch(addPackage())
    }

    const handleImageUpload = async (e, packageIndex, imageIndex) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            alert.info("Only images can be uploaded.")
            return;
        }
        setDisableUpload(true)
        const imageFinal = GenUtilities.removeSpacesFromName(`package/${vendorId}/${Date.now()}_${file.name}`);
        const registerImage = file;
        const data = {
            imageName: imageFinal,
            type: "products",
        };
        try {
            const response = await api.product.saveProductImage(data);
            await axios({
                method: "put",
                url: response.data,
                data: registerImage,
                onUploadProgress: (progressEvent) => {
                    dispatch((setUploadProgress(packageIndex, Math.round((progressEvent.loaded / progressEvent.total) * 100))))
                },
            });
            dispatch(updatePackage(packageIndex, {
                ...packages[packageIndex],
                images: packages[packageIndex].images.map((img, idx) =>
                    idx === imageIndex ? imageFinal : img
                )
            }));
            setDisableUpload(false)
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    // Handle input changes for each package
    const handleInputChange = (e, packageIndex) => {
        const { name, value } = e.target;
        dispatch(updatePackage(packageIndex, { ...packages[packageIndex], [name]: value }))
    };

    // Save package data to state
    const handleAddPackages = () => {
        const isValid = validatePackages();
        if (!isValid) {
            return;
        }
        props.handleSubmit(packages);
    };

    const handleImageDelete = (packageIndex, imageIndex) => {
        if (!disableUpload) {
            const updatedPackages = [...packages];
            updatedPackages[packageIndex].images[imageIndex] = "";
            dispatch(updatePackage(packageIndex, updatedPackages[packageIndex]))
        }
    };

    // reset packages
    const reset = () => {
        dispatch(resetPackages())
    }

    // Validation
    const validatePackages = () => {
        for (const pkg of packages) {
            if (!pkg.productName || pkg.productName === "" || pkg.productName === null || pkg.productName === undefined || !pkg.productName.trim()) {
                alert.info("All fields are required for each package.");
                return false;
            }

            // if (pkg.images.some((img) => img === "") || pkg.images.length < 4 || pkg.images.some((img) => img === null)) {
            //     alert.info("All images must be uploaded for each package.");
            //     return false;
            // }
            if (pkg.packageLength <= 0 || pkg.packageWidth <= 0 || pkg.packageHeight <= 0) {
                alert.info("Values must be greater than 0.");
                return false;
            }
            if (!pkg.weight || !pkg.actualWeight) {
                alert.info("All fields are required for each package.");
                return false;
            }
            if (pkg.weight <= 0 || pkg.actualWeight <= 0) {
                alert.info("Values must be greater than 0.");
                return false;
            }
            if (Number(pkg.weight) < Number(pkg.actualWeight)) {
                alert.info("After packaging weight cannot be less than package weight.");
                return false;
            }
        }
        return true;
    };

    // popup
    const handleClose = () => {
        setShow(false)
    }

    // SL-824
    const handleAcceptPackage = () => {
        const isValid = validatePackages();
        if (!isValid) {
            return;
        }
        props.handleAcceptPackage("V_ACTIVE");
    }

    // Sl-885

    const handleDimensionUnitChange = (e, index) => {
        dispatch({ type: "SET_PACKAGE_DIMENSION_UNIT", payload: e.target.value })
    }

    const getVWeight = (pkg) => {
        if (pkg === undefined || pkg === "" || pkg === null || pkg.packageLength === "" || pkg.packageWidth === "" || pkg.packageHeight === "") {
            return 0;
        }
        return (pkg.packageLength * pkg.packageWidth * pkg.packageHeight) / 5000;
    }


    const handleRejectPackage = () => {
        setShowWeightRequestBox(false);
        if (props?.handleRejectPackage) {
            props.handleRejectPackage("V_REJECT");
        }
    }

    const editPkg = () => {
        dispatch(setEditBtn(true))
        setEditMode(true)
    }

    return (
        props?.viewOnly && !editMode ?
            <>
                {
                    packages && packages.map((pkg, packageIndex) => {
                        const images = pkg?.images
                        return (
                            <div key={packageIndex}>
                                <span style={styles.spanPackage}>Package {packageIndex + 1}</span>
                                <div style={{ ...styles.outerContainer, border: "1px ridge" }}>
                                    {isEditBtnActive && <div style={styles.editCntnDiv}>
                                        <button style={styles.editBtnStyle} onClick={() => editPkg()}><i className="bi bi-pencil"></i></button>
                                    </div>}
                                    <Progress value={uploadProgress[packageIndex]} />
                                    <div style={styles.container}>
                                        <div style={styles.column("25%")}>
                                            <div style={styles.imageGrid}>
                                                {[0, 1, 2, 3].map((image) => (
                                                    images[image] !== "" && images[image] !== null && images[image] !== undefined ?
                                                        <div key={image} style={styles.imageUpload}>
                                                            <img src={"https://s3.toolsvilla.com/products/" + images[image]}
                                                                alt={`image-${image}`}
                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                            />
                                                        </div> :
                                                        <>
                                                        <div key={image} style={styles.imageUpload}>
                                                            <img src="/pkg_img_placeholder.png"
                                                                alt={`image-${image}`}
                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                            />
                                                            </div>
                                                        </>
                                                ))}
                                            </div>
                                        </div>

                                        <div style={styles.column("40%")}>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>Package Name</label>
                                                <input
                                                    type="text"
                                                    style={styles.input}
                                                    placeholder="Enter Package name"
                                                    name="productName"
                                                    value={pkg.productName}
                                                    disabled="true"
                                                    onChange={(e) => handleInputChange(e, packageIndex)}
                                                />
                                            </div>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>Dimensions <select value={dimensionUnit} onChange={(e) =>
                                                    handleDimensionUnitChange(e, packageIndex)
                                                } style={styles.dimensionSelect}>
                                                    <option value="ft">ft</option>
                                                    <option value="cm">cm</option>
                                                </select></label>
                                                <div style={styles.row}>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                        placeholder="Width"
                                                        name="packageWidth"
                                                        disabled="true"
                                                        value={GenUtilities.roundOfftoTwoDecimals(dimensionUnit === "ft" ? pkg.packageWidth : ftToCm(pkg.packageWidth))}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.starIcon}>*</span>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                        placeholder="Height"
                                                        name="packageHeight"
                                                        disabled="true"
                                                        value={GenUtilities.roundOfftoTwoDecimals(dimensionUnit === "ft" ? pkg.packageHeight : ftToCm(pkg.packageHeight))}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.starIcon}>*</span>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                        placeholder="Length"
                                                        name="packageLength"
                                                        disabled="true"
                                                        value={GenUtilities.roundOfftoTwoDecimals(dimensionUnit === "ft" ? pkg.packageLength : ftToCm(pkg.packageLength))}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                </div>
                                            </div>
                                            <p style={styles.volWeightTitle}>(Volumetric Weight : {GenUtilities.roundOfftoTwoDecimals(pkg.vWeight)} kg)</p>
                                        </div>

                                        <div style={styles.column("30%")}>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>Package Weight</label>
                                                <div style={styles.row}>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, width: '100px' }}
                                                        placeholder=""
                                                        disabled="true"
                                                        name="actualWeight"
                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.actualWeight)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.kgLabel}>kg</span>
                                                </div>
                                            </div>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>After Packaging (Package Weight)</label>
                                                <div style={styles.row}>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, width: '100px' }}
                                                        placeholder=""
                                                        disabled="true"
                                                        name="weight"
                                                        onWheel={(e) => e.target.blur()}
                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.weight)}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.kgLabel}>kg</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {props?.weightChangeStatus === "T_PENDING" ?
                                    <p className="text-danger fs-12">
                                        Your requested weight is pending
                                        for verification from Toolsvilla</p> : <></>}
                                {props?.weightChangeStatus === "T_REJECT" && props?.showRejectMessage && 
                                    <p className="text-danger fs-12">
                                        The dimension request has been rejected.Please update again.</p>}
                            </div>
                        )
                    })}
                {props?.isControls === "no" ? null : <div style={styles.updateBtnContainer}>
                    {packages && packages.length > 0 &&

                        props?.backButton ? <button style={styles.backBtn} onClick={() => props.handleBackPressWeight()}>
                        {props?.backButton}
                    </button> : null
                    }{
                        props.proceedButton ? <button style={styles.updateBtn} onClick={() => props.proceed()}>
                            {props?.proceedButton}
                        </button> : <></>
                    }
                </div>

                }
            </> :
            packages && packages.length > 0 ?
                <div style={{ textAlign: "left" }}>

                    {
                        props?.source === "Forms" ? <div>
                            <span style={formSpecificStyles.spanNoPackage}>No. of Packages</span>
                            <select style={formSpecificStyles.select} value={packageCount} onChange={handlePackageCountChange}>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((num) => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                            </select>
                            <button style={formSpecificStyles.addButton} onClick={() => addPackages()}>Add</button>
                            <button style={formSpecificStyles.resetButton} onClick={() => {
                                reset()
                            }}>Reset</button>
                        </div>
                            : <div>
                                <span style={styles.spanNoPackage}>No. of Packages</span>
                                <select style={styles.select} value={packageCount} onChange={handlePackageCountChange}>
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((num) => (
                                        <option key={num} value={num}>{num}</option>
                                    ))}
                                </select>
                                <button style={styles.addButton} onClick={() => addPackages()}>Add</button>
                                <button style={styles.resetButton} onClick={() => {
                                    reset()
                                }}>Reset</button>
                            </div>
                    }

                    {packages && packages.map((pkg, packageIndex) => {
                        const images = pkg?.images
                        return (
                            <div key={packageIndex}>
                                <span style={styles.spanPackage}>Package {packageIndex + 1}</span>
                                <div style={styles.outerContainer}>
                                    <Progress value={uploadProgress[packageIndex]} />
                                    <div style={styles.container}>
                                        <div style={styles.column("25%")}>
                                            <div style={styles.imageGrid}>
                                                {[0, 1, 2, 3].map((image) => (
                                                    <div key={image} style={styles.imageUpload}>
                                                        {images[image] ? (
                                                            <>
                                                                <img src={"https://s3.toolsvilla.com/products/" + images[image]}
                                                                    alt={`image-${image}`}
                                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                />
                                                                <i className="bi bi-trash3" style={styles.deleteIcon} onClick={() => handleImageDelete(packageIndex, image)}></i>
                                                            </>
                                                        ) : (
                                                            <>

                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    disabled={disableUpload}
                                                                    onChange={(e) => handleImageUpload(e, packageIndex, image)}
                                                                    style={{ position: "absolute", opacity: 0, width: "100%", height: "100%", cursor: "pointer" }}
                                                                />
                                                                <i className="bi bi-upload"></i>
                                                            </>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            <p style={styles.uploadImagesLabel}><i className="bi bi-upload"></i> Upload Images</p>
                                            <p style={styles.uploadImagesGuide} onClick={() => setShow(true)}><i className="bi bi-info-circle"></i> Image upload guidenlines</p>
                                        </div>

                                        <div style={styles.column("40%")}>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>Package Name</label>
                                                <input
                                                    type="text"
                                                    style={styles.input}
                                                    placeholder="Enter Package name"
                                                    name="productName"
                                                    value={pkg.productName}
                                                    disabled={disableUpload}
                                                    onChange={(e) => handleInputChange(e, packageIndex)}
                                                />
                                            </div>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>Dimensions <select onChange={(e) => {
                                                    handleDimensionUnitChange(e, packageIndex)
                                                    // sl-885(1-9-25)
                                                    if (!disableUpload) {
                                                        dispatch(resetPackageDimensions(packageIndex))
                                                    }
                                                }} style={styles.dimensionSelect} value={dimensionUnit}>
                                                    <option value="ft">ft</option>
                                                    <option value="cm">cm</option>
                                                </select></label>
                                                <div style={styles.row}>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                        placeholder="Width"
                                                        name="packageWidth"
                                                        disabled={disableUpload}
                                                        // sl-885(1-9-25)
                                                        value={disableUpload === true ? GenUtilities.roundOfftoTwoDecimals(dimensionUnit === "ft" ? pkg.packageWidth : ftToCm(pkg.packageWidth)) : GenUtilities.roundOfftoTwoDecimals(pkg.packageWidth)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.starIcon}>*</span>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                        placeholder="Height"
                                                        name="packageHeight"
                                                        disabled={disableUpload}
                                                        // sl-885(1-9-25)
                                                        value={disableUpload === true ? GenUtilities.roundOfftoTwoDecimals(dimensionUnit === "ft" ? pkg.packageHeight : ftToCm(pkg.packageHeight)) : GenUtilities.roundOfftoTwoDecimals(pkg.packageHeight)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.starIcon}>*</span>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                        placeholder="Length"
                                                        name="packageLength"
                                                        disabled={disableUpload}
                                                        // sl-885(1-9-25)
                                                        value={disableUpload === true ? GenUtilities.roundOfftoTwoDecimals(dimensionUnit === "ft" ? pkg.packageLength : ftToCm(pkg.packageLength)) : GenUtilities.roundOfftoTwoDecimals(pkg.packageLength)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                </div>
                                            </div>
                                            <p style={styles.volWeightTitle}>(Volumetric Weight : {GenUtilities.roundOfftoTwoDecimals(pkg.vWeight)} kg)</p>
                                        </div>

                                        <div style={styles.column("30%")}>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>Package Weight</label>
                                                <div style={styles.row}>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, width: '100px' }}
                                                        placeholder=""
                                                        disabled={disableUpload}
                                                        name="actualWeight"
                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.actualWeight)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.kgLabel}>kg</span>
                                                </div>
                                            </div>
                                            <div style={styles.inputGroup}>
                                                <label style={styles.label}>After Packaging (Package Weight)</label>
                                                <div style={styles.row}>
                                                    <input
                                                        type="number"
                                                        style={{ ...styles.input, width: '100px' }}
                                                        placeholder=""
                                                        disabled={disableUpload}
                                                        name="weight"
                                                        onWheel={(e) => e.target.blur()}
                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.weight)}
                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                    />
                                                    <span style={styles.kgLabel}>kg</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    )}

                    {props?.weightChangeStatus === "T_REJECT" && props?.showRejectMessage && 
                                    <p className="text-danger fs-11">
                                        The dimension request has been rejected.Please update again.</p>}

                    {
                        props?.weightRequest && showWeightRequestBox && !isPackageNull && <div style={styles.weightRequest.container}>
                            <p style={styles.weightRequest.label}>Weight and Dimension Verification Request From Toolsvilla. Do you want to accept it?</p>
                            <div style={styles.weightRequest.btnContainer}>
                                <button
                                    style={{ ...styles.weightRequest.button, ...styles.weightRequest.noBtn }}
                                    onClick={handleRejectPackage}
                                >
                                    No
                                </button>
                                <button style={{ ...styles.weightRequest.button, ...styles.weightRequest.yesBtn }} className="yes-button" onClick={() => handleAcceptPackage()}>Yes</button>
                            </div>
                        </div>
                    }

                    {props?.isControls === "no" ? null : <div style={styles.updateBtnContainer}>
                        {packages && packages.length > 0 &&

                            props?.backButton ? <button style={styles.backBtn} onClick={() => props.handleBackPressWeight()}>
                            {props?.backButton}
                        </button> : null
                        }
                        {
                            props?.weightRequest && showWeightRequestBox ? <></> : <button style={styles.updateBtn} onClick={() => handleAddPackages()}>
                                Update
                            </button>
                        }
                    </div>

                    }
                    {props?.source === "Forms" ? <></> : referencePackages && referencePackages.length > 0 && <>

                        <p style={{ fontSize: '12px', cursor: 'pointer' }}><span onClick={() => setShowReference(true)}><i className="bi bi-info-circle"></i> View package details of other sellers (for reference)</span>
                            {showReference && <button style={styles.refCloseBtn} onClick={() => setShowReference(false)}>Hide</button>}
                        </p>
                        {
                            showReference &&
                            <div className="mt-2" style={{ background: 'whitesmoke', padding: '2px' }}>
                                {
                                    referencePackages && referencePackages.length < 1 ? <p className="text-center fs-12">Package not available currently.</p> : <></>
                                }
                                {
                                    referencePackages && referencePackages.map((pkg, packageIndex) => {
                                        const images = pkg?.images
                                        return (
                                            <div key={packageIndex}>
                                                <span style={styles.spanPackage}>Package {packageIndex + 1}</span>
                                                <div style={{ ...styles.outerContainer, border: "1px ridge" }}>
                                                    <Progress value={uploadProgress[packageIndex]} />
                                                    <div style={styles.container}>
                                                        <div style={styles.column("25%")}>
                                                            <div style={styles.imageGrid}>
                                                                {[0, 1, 2, 3].map((image) => (
                                                                    <div key={image} style={styles.imageUpload}>
                                                                        <img src={"https://s3.toolsvilla.com/products/" + images[image]}
                                                                            alt={`image-${image}`}
                                                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div style={styles.column("40%")}>
                                                            <div style={styles.inputGroup}>
                                                                <label style={styles.label}>Package Name</label>
                                                                <input
                                                                    type="text"
                                                                    style={styles.input}
                                                                    placeholder="Enter Package name"
                                                                    name="productName"
                                                                    value={pkg.productName}
                                                                    disabled="true"
                                                                    onChange={(e) => handleInputChange(e, packageIndex)}
                                                                />
                                                            </div>
                                                            <div style={styles.inputGroup}>
                                                                <label style={styles.label}>Dimensions (in ft.)</label>
                                                                <div style={styles.row}>
                                                                    <input
                                                                        type="number"
                                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                                        placeholder="Width (ft)"
                                                                        name="packageWidth"
                                                                        disabled="true"
                                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.packageWidth)}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                                    />
                                                                    <span style={styles.starIcon}>*</span>
                                                                    <input
                                                                        type="number"
                                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                                        placeholder="Height (ft)"
                                                                        name="packageHeight"
                                                                        disabled="true"
                                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.packageHeight)}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                                    />
                                                                    <span style={styles.starIcon}>*</span>
                                                                    <input
                                                                        type="number"
                                                                        style={{ ...styles.input, ...styles.thirdWidth }}
                                                                        placeholder="Length (ft)"
                                                                        name="packageLength"
                                                                        disabled="true"
                                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.packageLength)}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <p style={styles.volWeightTitle}>(Volumetric Weight : {GenUtilities.roundOfftoTwoDecimals(pkg.vWeight)} kg)</p>
                                                        </div>

                                                        <div style={styles.column("30%")}>
                                                            <div style={styles.inputGroup}>
                                                                <label style={styles.label}>Package Weight</label>
                                                                <div style={styles.row}>
                                                                    <input
                                                                        type="number"
                                                                        style={{ ...styles.input, width: '100px' }}
                                                                        placeholder=""
                                                                        disabled="true"
                                                                        name="actualWeight"
                                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.actualWeight)}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                                    />
                                                                    <span style={styles.kgLabel}>kg</span>
                                                                </div>
                                                            </div>
                                                            <div style={styles.inputGroup}>
                                                                <label style={styles.label}>After Packaging (Package Weight)</label>
                                                                <div style={styles.row}>
                                                                    <input
                                                                        type="number"
                                                                        style={{ ...styles.input, width: '100px' }}
                                                                        placeholder=""
                                                                        disabled="true"
                                                                        name="weight"
                                                                        onWheel={(e) => e.target.blur()}
                                                                        value={GenUtilities.roundOfftoTwoDecimals(pkg.weight)}
                                                                        onChange={(e) => handleInputChange(e, packageIndex)}
                                                                    />
                                                                    <span style={styles.kgLabel}>kg</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }</div>
                        }
                    </>}

                    <Modal className="imageUploadGuide" centered show={show} onHide={handleClose} >
                        <Modal.Header closeButton>
                            <Modal.Title></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h5>Upload Packed Product Dimensions and Weight</h5>
                            <div className="imgContainer">
                                <div className="imgUploadGuideImgs"><img src={img1} alt="img1" />
                                    <br />
                                    <p className="my-1">Image 1 : Package Length</p></div>
                                <div className="imgUploadGuideImgs"><img src={img2} alt="img2" /> <br />
                                    <p className="my-1">Image 2 : Package Width</p></div>
                            </div>
                            <div className="imgContainer">
                                <div className="imgUploadGuideImgs"><img src={img3} alt="img3" /> <br />
                                    <p className="my-1">Image 3 : Package Height</p></div>
                                <div className="imgUploadGuideImgs"><img src={img4} alt="img4" /> <br />
                                    <p className="my-1">Image 4 : Package Weight</p></div>
                            </div>
                        </Modal.Body>
                    </Modal>

                </div> : <></>
    )
};

export default WeightComponent;
